import classnames from "classnames";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import CardHeader from "./CardHeader";

import "./card.scss";

const Card = ({
  children,
  className,
  id,
  title,
  description,
  subtitle,
  showAsterisk,
  headerIcon,
  headerNumber,
  headerCTA,
  collapsible,
  collapseText,
  disabled,
  openByDefault,
  tooltip,
  errorCount,
  setIsUserProposals,
  isUserProposals,
  proposalCounts,
  isCardWithTable,
  showProposalsToggle,
  isLocked,
}) => {
  const [isExpanded, setIsExpanded] = useState(openByDefault);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    setIsExpanded(openByDefault);
  }, [openByDefault]);

  return (
    <div
      className={classnames("card", className, { disabled: disabled })}
      aria-hidden={disabled}
    >
      {title && (
        <CardHeader
          id={id}
          title={title}
          headerIcon={headerIcon}
          headerNumber={headerNumber}
          subtitle={subtitle}
          headerCTA={headerCTA}
          collapseText={collapseText}
          showAsterisk={showAsterisk}
          description={description}
          collapsible={collapsible}
          isExpanded={isExpanded}
          errorCount={errorCount}
          tooltip={tooltip}
          disabled={disabled}
          handleClick={handleClick}
          setIsUserProposals={setIsUserProposals}
          isUserProposals={isUserProposals}
          proposalCounts={proposalCounts}
          isCardWithTable={isCardWithTable}
          showProposalsToggle={showProposalsToggle}
          isCardLocked={isLocked}
        />
      )}

      {(collapsible || (!disabled && isExpanded)) && (
        <section
          id={`${id}-panel`}
          aria-labelledby={collapsible ? `${id}-header` : null}
          hidden={collapsible && !isExpanded}
          className={classnames("card__section", { "content-only": !title })}
        >
          {children}
        </section>
      )}
    </div>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  subtitle: PropTypes.string,
  showAsterisk: PropTypes.bool,
  headerIcon: PropTypes.string,
  headerNumber: PropTypes.string,
  headerCTA: PropTypes.node,
  collapsible: PropTypes.bool,
  collapseText: PropTypes.bool,
  disabled: PropTypes.bool,
  openByDefault: PropTypes.bool,
  tooltip: PropTypes.object,
  errorCount: PropTypes.number,
  setIsUserProposals: PropTypes.func,
  isUserProposals: PropTypes.bool,
  proposalCounts: PropTypes.object,
  isCardWithTable: PropTypes.bool,
  showProposalsToggle: PropTypes.bool,
  isLocked: PropTypes.bool,
};

Card.defaultProps = {
  collapseText: true,
  openByDefault: false,
  disabled: false,
  title: "",
  isCardWithTable: false,
  showProposalsToggle: false,
};

export default Card;
